"use strict";

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EventIterator = /*#__PURE__*/function () {
  function EventIterator(listen, remove) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, EventIterator);

    this.listen = listen;
    this.remove = remove;
    this.options = Object.assign({
      highWaterMark: 100
    }, options);
    Object.freeze(this);
  }

  _createClass(EventIterator, [{
    key: Symbol.asyncIterator,
    value: function value() {
      var _this = this;

      var placeholder;
      var queue = [];
      var listen = this.listen;
      var remove = this.remove;

      var push = function push(value) {
        var resolution = {
          value: value,
          done: false
        };

        if (placeholder) {
          placeholder.resolve(resolution);
          placeholder = undefined;
        } else {
          queue.push(Promise.resolve(resolution));
          var highWaterMark = _this.options.highWaterMark;

          if (highWaterMark !== undefined && queue.length >= highWaterMark && console) {
            console.warn("EventIterator queue reached ".concat(queue.length, " items"));
          }
        }
      };

      var stop = function stop() {
        if (remove) {
          remove(push, stop, fail);
        }

        var resolution = {
          done: true
        };

        if (placeholder) {
          placeholder.resolve(resolution);
          placeholder = undefined;
        } else {
          queue.push(Promise.resolve(resolution));
        }
      };

      var fail = function fail(error) {
        if (remove) {
          remove(push, stop, fail);
        }

        if (placeholder) {
          placeholder.reject(error);
          placeholder = undefined;
        } else {
          var rejection = Promise.reject(error);
          /* Attach error handler to avoid leaking an unhandled promise rejection. */

          rejection.catch(function () {});
          queue.push(rejection);
        }
      };

      listen(push, stop, fail);
      return {
        next: function next(value) {
          if (queue.length) {
            return queue.shift();
          } else {
            return new Promise(function (resolve, reject) {
              placeholder = {
                resolve: resolve,
                reject: reject
              };
            });
          }
        },
        return: function _return() {
          if (remove) {
            remove(push, stop, fail);
          }

          return Promise.resolve({
            done: true
          });
        }
      };
    }
  }]);

  return EventIterator;
}();

exports.EventIterator = EventIterator;
exports.default = EventIterator;